// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + chunkId + "." + {"175": "7b8b8090e6e9adb7","309": "827627517f6c89e4","327": "96ade007dbb5cb76","352": "b1b164cd3136dbc6","504": "34433bf3b1371a2b","524": "4922213de427b34a","6": "ce3a3fbf079fad33","776": "5d4eadf1c3ff8e92","798": "86b5b2d0e378c2e8","843": "11a01ac13a2c3538","854": "d7e4538fd805010b","90": "946f6546494aa55a","921": "e827e0119ee42f05",}[chunkId] + ".bundle.js"
}